import {
    obtenerDatosCompletosFt
} from "../../utils/Constants";
import { ultimoAnalisis } from "../../utils/mapUtils";
import {API_BASE_URL_DASHBOARD} from "../../utils/config";


export const processFertilizacionData = (datosAnalisis, indicadores) => ({
    analisis: "FERTILIZACION",
    ...datosAnalisis,
    indicadores: {
        promedioAltura: {
            titulo: "Promedio de Altura",
            valor: indicadores.promedioAltura ? `${indicadores.promedioAltura} m` : ''
        },
        areaSobreAplicada: {
            titulo: "Área Sobre Aplicada",
            valor: indicadores.areaSobreAplicada ? `${indicadores.areaSobreAplicada} m` : ''
        },
        areaAplicada: {
            titulo: "Área aplicada",
            valor: indicadores.areaAplicada ? `${indicadores.areaAplicada} m` : ''
        },
        areaTotalLote: {
            titulo: "Área total del bloque",
            valor: indicadores.areaTotalLote ? `${indicadores.areaTotalLote} m` : ''
        },
        areaNoAplicada: {
            titulo: "Área no aplicada",
            valor: indicadores.areaNoAplicada ? `${indicadores.areaNoAplicada} m` : ''
        },
        areaFueraDeLote: {
            titulo: "Área fuera de lote",
            valor: indicadores.areaFueraDeLote ? `${indicadores.areaFueraDeLote} m` : ''
        },
        areaSobreCalles: {
            titulo: "Área sobre calles",
            valor: indicadores.areaSobreCalles ? `${indicadores.areaSobreCalles} m` : ''
        },
        porcentajeVariacionAreas: {
            titulo: "Porcentaje de Variación Areas",
            valor: indicadores.porcentajeVariacion ? `${indicadores.porcentajeVariacion}` : ''
        },
        promedioVelocidad: {
            titulo: "Promedio de Velocidad",
            valor: indicadores.promedioVelocidad ? `${indicadores.promedioVelocidad} km/h` : ''
        },
        diferenciaDeAreaApsKml: {
            titulo: "Diferencia de Área Aps Kml",
            valor: indicadores.diferenciaDeAreaApsKml ? `${indicadores.diferenciaDeAreaApsKml} m` : ''
        },
        dosisTotalRealAplicada: {
            titulo: "Dosis Total Real Aplicada",
            valor: indicadores.dosisTotalRealAplicada ? `${indicadores.dosisTotalRealAplicada} L` : ''
        }
    }
});


export const fetchDataFertilizacion = async (idAnalisisFertilizacion, setDatosAnalisis) => {
    try {
        const response = await obtenerDatosCompletosFt(idAnalisisFertilizacion);
        const datosResponse = response.data;
        const datos = {
            nombreResponsable: {
                titulo: "Responsable",
                valor: datosResponse.responsable || ""
            },
            nombreFinca: {
                titulo: "Nombre Finca",
                valor: datosResponse.nombreFinca || ""
            },
            codigoFinca: {
                titulo: "Código Finca",
                valor: datosResponse.codigoFinca || ""
            },
            lote: {
                titulo: "Lote",
                valor: datosResponse.lote || ""
            },
            nombreOperador: {
                titulo: "Nombre Operador",
                valor: datosResponse.nombreOperador || ""
            },
            zafra: {
                titulo: "Zafra",
                valor: datosResponse.zafra || ""
            },
            tercio: {
                titulo: "Tercio",
                valor: datosResponse.tercio || ""
            },
            fechaInicio: {
                titulo: "Fecha Inicio",
                valor: datosResponse.fechaInicio || ""
            },
            fechaFin: {
                titulo: "Fecha Final",
                valor: datosResponse.fechaFinal || ""
            },
            horaInicio: {
                titulo: "Hora Inicio",
                valor: datosResponse.horaInicio || ""
            },
            horaFin: {
                titulo: "Hora Fin",
                valor: datosResponse.horaFin || ""
            },
            codigoDeMaquina: {
                titulo: "Código de Máquina",
                valor: datosResponse.codigoDeMaquina || ""
            },
            eficiencia: {
                titulo: "Eficiencia",
                valor: typeof datosResponse.eficiencia === "number"
                    ? datosResponse.eficiencia.toFixed(2)
                    : ""
            },
            dosisTeorica: {
                titulo: "Dosis Teórica",
                valor: typeof datosResponse.dosisTeorica === "number"
                    ? datosResponse.dosisTeorica.toFixed(2)
                    : ""
            },
            anchoDeFaja: {
                titulo: "Ancho de Faja",
                valor: typeof datosResponse.anchoDeFaja === "number"
                    ? `${datosResponse.anchoDeFaja.toFixed(2)} m`
                    : ""
            },
            tchEstimado: {
                titulo: "TCH Estimado",
                valor: typeof datosResponse.tchEstimado === "number"
                    ? datosResponse.tchEstimado.toFixed(2)
                    : ""
            },
            equipo: {
                titulo: "Equipo",
                valor: datosResponse.equipo || ""
            },
            producto: {
                titulo: "Producto",
                valor: datosResponse.producto || ""
            },
            edadDias: {
                titulo: "Edad (días)",
                valor: typeof datosResponse.edadDias === "number"
                    ? datosResponse.edadDias.toFixed(0)
                    : ""
            },
            tiempoTotal: {
                titulo: "Tiempo Total",
                valor: datosResponse.tiempoTotal || ""
            },
            altura: {
                titulo: "Altura",
                valor: typeof datosResponse.altura === "number"
                    ? `${datosResponse.altura.toFixed(2)} m`
                    : ""
            },
            velocidad: {
                titulo: "Velocidad",
                valor: typeof datosResponse.velocidad === "number"
                    ? `${datosResponse.velocidad.toFixed(2)} km/h`
                    : ""
            },
            dosisReal: {
                titulo: "Dosis Real",
                valor: typeof datosResponse.dosisReal === "number" ?  `${datosResponse.dosisReal.toFixed(2)} km/h` : ""
            },
            diferenciaDosis: {
                titulo: "Diferencia Dosis",
                valor: typeof datosResponse.diferenciaDosis === "number" ? `${datosResponse.diferenciaDosis.toFixed(2)} L/ha` : ""
            },
            porcentajeVariacion: {
                titulo: "Porcentaje de Variación Dosis",
                valor: typeof  datosResponse.porcentajeVariacion === "number" ? `${datosResponse.porcentajeVariacion.toFixed(2) } %` : ""
            }
        };


        setDatosAnalisis(datos);
    } catch (error) {
        console.error("Error al cargar datos de Fertilización:", error);
    }
};


export const shouldEnableExecBashFertilizacion = (selectedFile) => {
    return selectedFile !== null;
};


export const fetchDataFertilizacionIndicators = async (startDate, endDate, endpoint, idUsuario, minMaxParams, filters = {}, { signal } = {}) => {
    try {
        const queryParams = new URLSearchParams({
            FECHA_INICIO: startDate,
            userId: idUsuario,
            FECHA_FINAL: endDate,
            minMax: JSON.stringify(minMaxParams),
            NOMBRE_DE_OPERADOR: filters.operadorFR || '',
            NOMBRE_FINCA: filters.fincaFR || '',
            PRODUCTO: filters.productoFR || '',
            ZAFRA: filters.zafraFR || '',
            TERCIO: filters.tercioFR || '',
            FILTER_USER_IDS: filters.FILTER_USER_IDS || '',
        }).toString();


        const response = await fetch(`${API_BASE_URL_DASHBOARD}api/indicators/fertilizacion/${endpoint}?${queryParams}`, { signal });
        const data = await response.json();

        return data.map(item => {
            const indicadores = {
                _id: item._id || null
            };

            Object.keys(item).forEach(key => {
                const indicador = item[key];

                if (indicador && typeof indicador === 'object' && 'valor' in indicador && 'titulo' in indicador) {
                    indicadores[key] = {
                        title: indicador.titulo,
                        value: indicador.valor
                    };
                }
            });

            return indicadores;
        });
    } catch (error) {
        console.error("Error al obtener los indicadores de aplicaciones aéreas:", error);
        return [];
    }
};


export const cargaDatosFertilizacion = async (userData, selectedAnalysisTypeRef) => {
    if (selectedAnalysisTypeRef.current && userData.userId) {
        try {
            const response = await ultimoAnalisis(selectedAnalysisTypeRef, userData.userId);
            if (response && response.data && response.data.ID_ANALISIS) {
                return response;
            } else {
                console.error("Respuesta del último análisis no contiene datos esperados");
            }
        } catch (error) {
            console.error("Error al obtener último análisis:", error);
        }
    }
};
